import {useState, useEffect} from "preact/compat"
import {useCookies} from "../../../hooks";

export const useSocialIntegration = () => {
    const [showSocialIntegration, setShowSocialIntegration] = useState(false);
    // Cookie to set the component not to render twice
    const [mustRender, setMustRender] = useCookies("mustRenderSocialLoginComponent", true);

    const handleShowSocialIntegration = () => {
        setShowSocialIntegration((prevState) => !prevState);
    }

    // Controls whether the component should be re-rendered when entering the page again or not
    useEffect(() => {
        if (!mustRender) {
            return;
        }

        setShowSocialIntegration(true);
        setMustRender(false);
    }, []);

    return {
        showSocialIntegration,
        mustRender,
        handleShowSocialIntegration
    }
}
